<div class="container-fluid p-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2 class="m-0 fs-4 fw-semibold">{{ 'USER_FORM.SELECT_SF_CONTACT' | translate }}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="mb-4">
    <div class="mb-3">
      <app-icam-input
        [label]="'USER_FORM.SEARCH_SF_CONTACT' | translate"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange($event)"
        [isSlim]="true"
        [placeholder]="'USER_FORM.SEARCH_SF_CONTACT_PLACEHOLDER' | translate"
      ></app-icam-input>
    </div>

    @if (!isLoading) {
      <div class="border rounded contacts-list">
        @if (filteredContacts.length > 0) {
          <div>
            @for (contact of filteredContacts; track contact) {
              <div
                class="p-1 contact-item"
                role="button"
                (click)="selectContact(contact)"
                (keydown.enter)="selectContact(contact)"
                tabindex="0"
              >
                <div>
                  <div class="fw-medium mb-1">{{ getContactFullName(contact) }}</div>
                  <div class="small text-secondary">{{ getContactEmail(contact) }}</div>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="p-4 text-center text-secondary">
            {{ 'USER_FORM.NO_CONTACTS_FOUND' | translate }}
          </div>
        }
      </div>
    } @else {
      <div class="d-flex justify-content-center p-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }
  </div>

  <div class="d-flex justify-content-end">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
  </div>
</div>
